export const getValueToPersist = ({
  valueBeforeCookieConsent,
  valueAfterCookieConsent,
}: {
  valueBeforeCookieConsent: unknown;
  valueAfterCookieConsent: unknown;
}) => {
  let valueToPersist: string;
  if (typeof valueAfterCookieConsent === 'string') {
    valueToPersist = valueAfterCookieConsent;
  } else if (Array.isArray(valueAfterCookieConsent)) {
    const beforeCookieConsent = Array.isArray(valueBeforeCookieConsent)
      ? valueBeforeCookieConsent
      : [];
    const afterCookieConsent = Array.isArray(valueAfterCookieConsent)
      ? valueAfterCookieConsent
      : [];

    const difference = afterCookieConsent.filter(
      value => !beforeCookieConsent.includes(value),
    );
    valueToPersist = JSON.stringify(difference);
  } else {
    valueToPersist = JSON.stringify(valueAfterCookieConsent);
  }

  return valueToPersist;
};
